import { render, staticRenderFns } from "./AusTermsAndConditionsContent.vue?vue&type=template&id=584fc892"
import script from "./AusTermsAndConditionsContent.vue?vue&type=script&lang=js"
export * from "./AusTermsAndConditionsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports